import React from 'react';
import clsx from 'clsx';
import { User } from '@interfaces/models/user';
import ProfilePicture from '@components/molecules/profile/profile-picture';
import styles from './product-seller-badge.module.scss';

interface SellerInterface {
  id: string;
  firstname: string;
  picture: {
    path: string | undefined;
    alt: string;
  };
}
interface ProductSellerBadgeProps {
  seller?: User | SellerInterface;
  className?: string;
}

const ProductSellerBadge: React.FC<ProductSellerBadgeProps> = (props) => {
  const { seller, className } = props;

  if (!seller) {
    return null;
  }
  return (
    <ProfilePicture
      picturePath={seller?.picture?.path}
      isUserProfile={false}
      userId={seller.id}
      width={96}
      height={96}
      disableLazyLoad={true}
      wrapperProps={{ className: clsx(styles.sellerBadge__imageBlock, className ?? '') }}
      alt={seller?.picture?.alt}
    />
  );
};

export default ProductSellerBadge;
